import { request } from '@/http'
import { HTTPResponse, IdNamePair } from '@/types/common'
import {
  RegionItem,
} from '@/types/dict'

const baseURL = '/metis-data-dict/api'

// 获取全量地区
export function fetchAllRegions() {
  return request({
    baseURL,
    url: '/regions',
    method: 'GET',
  }).then((res) => res.data as HTTPResponse<RegionItem>)
}

export function getAdministrativeRegions() {
  return request({
    baseURL,
    url: '/regions/include/administrative/area',
    method: 'GET',
  }).then((res) => res.data as HTTPResponse<RegionItem>)
}

// 根据 regionId 获取地区链
export function getAllRegionsByRegionId(regionId: number) {
  return request({
    baseURL,
    url: `/regions/${regionId}/path`,
    method: 'GET',
  }).then((res) => res.data as HTTPResponse<RegionItem[]>)
}

// 获取年级列表
export function getGrades() {
  return request({
    baseURL,
    url: '/grades',
    method: 'GET',
  }).then((res) => res.data as HTTPResponse<IdNamePair[]>)
}

// 获取学期字典
export function getSemesters() {
  return request({
    baseURL,
    url: '/semesters',
    method: 'GET',
  }).then((res) => res.data as HTTPResponse<IdNamePair[]>)
}
